exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".call-to-action1[data-v-d48f136a] {\n  cursor: pointer;\n}\n.mutuo_label[data-v-d48f136a] {\n  border: 0;\n  color: black !important;\n  padding-left: 0 !important;\n  cursor: auto !important;\n}", ""]);

// exports
